import { render, staticRenderFns } from "./adminCompanyadd.vue?vue&type=template&id=0e5f6d20"
import script from "./adminCompanyadd.vue?vue&type=script&lang=js"
export * from "./adminCompanyadd.vue?vue&type=script&lang=js"
import style0 from "./adminCompanyadd.vue?vue&type=style&index=0&id=0e5f6d20&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports